import { Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, merge, Observable, Subscription } from 'rxjs';
import { debounceTime, first } from 'rxjs/operators';
import { User } from 'src/app/db/models/user';
import { GenericValidator } from 'src/app/directives/generic-validator';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  lform: FormGroup;

  user = new User();
  loading = false;
  currentUser: User;
  private sub: Subscription;

  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  constructor(private fb: FormBuilder,
              private router: Router,
              private authenticate: AuthenticationService,
              private notify: ToastrService,
              private uService: UserService)
  {

    if (this.authenticate.currentUserValue) {
      this.router.navigate(['/']);
    }

    this.validationMessages = {

      username: {
        required: 'username is required'
      },
      password: {
        required: 'Password is required'
      }

    }

      this.genericValidator = new GenericValidator(this.validationMessages);
  }

  ngOnInit() {
    this.createForm();
  }

  createForm(){
    this.lform = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  login(){
    this.loading = true;
    this.mapEntity();
    this.authenticate.login(this.user.username, this.user.password)
      .pipe(first())
      .subscribe(
        data => {
          this.router.navigate(['/']);
          this.notify.success('Login Succesful');
        },
        error => {
          // this.errorMessage = error;
          this.loading = false;
          this.notify.error('System Operator!', 'Username or Password incorrect!!!');
        }
      )
  }

  ngAfterViewInit(): void{

    const controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));

    merge(this.lform.valueChanges, ...controlBlurs).pipe(
      debounceTime(800)
    ).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.lform);
    });

  }


  get username() {
    return this.lform.controls.username as FormControl;
  }

  get password() {
    return this.lform.controls.password as FormControl;
  }

  mapEntity(): void {
    this.user.username = this.username.value;
    this.user.password = this.password.value;
  }

}
